// extracted by mini-css-extract-plugin
module.exports = {"map":"map-module--map--3Xbi9","textWrapper":"map-module--textWrapper--1-aEZ","mapImage":"map-module--mapImage--ytfoM","paragraphGroup":"map-module--paragraphGroup--2DvO3"};